import { useState, useEffect } from "react";
import { Box, Flex, useMediaQuery } from "@chakra-ui/react";

import DesktopNav from "./DesktopNav";
import MobileNav from "./MobileNav";

import {
  IoLogoInstagram,
  IoLogoFacebook,
  IoLogoTwitter,
  IoLogoYoutube,
  IoLogoTiktok,
} from "react-icons/io5";

import homeIcon from "../assets/Nav-Icons/LBPortal_Graphic_Home.png";
import contactIcon from "../assets/Nav-Icons/LBPortal_Graphic_Contact.png";
import aboutIcon from "../assets/Nav-Icons/LeaderBored_Icon_About.png";
import bookIcon from "../assets/Nav-Icons/temp_book.png";
import newsIcon from "../assets/Nav-Icons/temp_news.png";
// import triviaIcon from "../assets/Nav-Icons/temp_trivia.png";


const Navbar = ({ isSidebarToggled, setIsSidebarToggled }) => {
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");
  const [isVisible, setVisible] = useState(true);
  const [lastScroll, setLastScroll] = useState(0);

  const navItems = [
    {
      text: "Home",
      path: "/",
      icon: homeIcon,
    },
    {
      text: "About",
      path: "/about",
      icon: aboutIcon,
    },
    
    {
      text: "Comics",
      path: "/comics",
      icon: bookIcon,
    },
    {
      text: "News",
      path: "/news",
      icon: newsIcon,
    },
    // {
    //   text: "Trivia",
    //   path: "/trivia",
    //   icon: triviaIcon,
    // },
    {
      text: "Contact",
      path: "/contact",
      icon: contactIcon,
    },
  ];

  const socialIcons = [
    {
      icon: IoLogoInstagram,
      link: "https://www.instagram.com/leaderboredgg/",
    },
    {
      icon: IoLogoFacebook,
      link: "https://www.facebook.com/LeaderBoredGames/",
    },
    {
      icon: IoLogoTwitter,
      link: "https://twitter.com/LeaderBoredGG/",
    },
    {
      icon: IoLogoYoutube,
      link: "https://www.youtube.com/channel/UCVJjC7WCRuhe8ENydNuQTgQ",
    },
    {
      icon: IoLogoTiktok,
      link: "https://www.tiktok.com/@leaderboredgg",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      if (currentScroll > lastScroll && currentScroll > 50) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScroll(currentScroll);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll)
  }, [lastScroll]);

  return (
    <Box
      pos='fixed'
      zIndex='99'
      w='100%'
      color='white'
      bg='primary'
      transition="transform 0.3s ease"
      transform={isVisible ? "translateY(0)" : "translateY(-100%)"}
    >
      <Flex
        justifyContent='space-between'
        alignItems='center'
        mx='auto'
        maxW='1200px'
        h={16}
        py='40px'
      >
        {isLargerThan768 && (
          <DesktopNav
            isSidebarToggled={isSidebarToggled}
            setIsSidebarToggled={setIsSidebarToggled}
          />
        )}
        {!isLargerThan768 && (
          <MobileNav navItems={navItems} socials={socialIcons} />
        )}
      </Flex>
    </Box>
  );
};

export default Navbar;
